import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

import { environment } from "../../environments/environment";
import { Payment } from "../models";
import { map, catchError } from "rxjs/operators";
import { of } from "rxjs/observable/of";
import {
  getFileNameFromResponseContentDisposition,
  checkIfTruncated,
  saveFile,
} from "./utils/file-download-helper";

@Injectable()
export class PaymentService {
  baseUrl: string = environment.serverUrl + "api/1/payment";

  constructor(private httpClient: HttpClient) {}

  getAllPayment(): Observable<Payment[]> {
    return this.httpClient.get<Payment[]>(this.baseUrl);
  }

  getPaginatedFilteredSortedPayments(
    pageIndex: number,
    itemPerPage: number,
    filters: Map<string, string>,
    criterias: Map<string, boolean>
  ): Observable<any> {
    const url = this._formateUrl(pageIndex, itemPerPage, filters, criterias);
    return this.httpClient
      .get<Payment[]>(encodeURI(url), { observe: "response" })
      .map((response) => ({
        headers: response.headers,
        res: <Payment[]>response.body,
      }));
  }

  downloadXLSFile(
    pageIndex: number,
    itemPerPage: number,
    filters: Map<string, any>,
    criterias: Map<string, boolean>
  ): any {
    const url = this._formateUrl(pageIndex, itemPerPage, filters, criterias);
    return this.httpClient
      .get<any>(encodeURI(url), {
        headers: { Accept: "application/octet-stream" },
        responseType: "blob" as "json",
        observe: "response",
      })
      .map((response) => {
        const fileName = getFileNameFromResponseContentDisposition(
          response,
          "payments.xls"
        );
        const isTruncated = checkIfTruncated(response);
        saveFile(response.body.slice(), fileName);
        return isTruncated;
      });
  }

  private _formateUrl(
    pageIndex: number,
    itemPerPage: number,
    filters: Map<string, string>,
    criterias: Map<string, boolean>
  ) {
    const offset = (pageIndex - 1) * itemPerPage;
    let url =
      this.baseUrl + "?pagination=" + offset + "-" + itemPerPage + "&sorts=";
    if (!criterias.size) {
      url += "payment.created desc";
    } else {
      Array.from(criterias.keys()).forEach(
        (c) => (url += c + (criterias.get(c) === true ? " asc" : " desc") + ",")
      );
      url = url.substring(0, url.length - 1);
    }
    if (filters !== undefined) {
      const filtersAsString = JSON.stringify(filters, (key, value) => {
        if (value !== null && value !== undefined && value !== "") {
          return value;
        }
      });
      if (filtersAsString.length > 2) {
        url += "&filters=" + filtersAsString;
      }
    }
    return url;
  }

  refund(payment: Payment): Observable<Payment> {
    return this.httpClient.post(this.baseUrl + "/refund", payment).pipe(
      map((res) => {
        return { ...res } as Payment;
      }),
      catchError((err) => {
        return of(err);
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/payment.service.ts